<template lang="pug">
  div(@click="$router.push(`/slide/${slide.id}`)").wrap-item-user-slide-card.cursor-pointer
    div.wrap-title-img.f.fh
      v-img(:src="slide.titleImg")
    div.wrap-info.py8
      span.fz16.bold.block {{slide.title}}
      span.fz14.line-clamp-2 {{slide.description}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-user-slide-card {
  border-bottom: $basic_border;
  .wrap-title-img {
    width: 100%;
    max-height: 420px;
    overflow: hidden;
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    slide: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  async created () {

  },
  methods: {

  }
}
</script>
